import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import "./styles/Style.css";

ReactDOM.render( 
  <Provider store={configureStore()}>
    <React.StrictMode >
    <App />
    </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);